import { CalendarDate } from '@internationalized/date';
import {
  CurrencyCode,
  LoadInput,
  LoadLineItemInput,
  WeightDisplayUnit,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createLoadAtom = createMutationAtomFactory(
  'trade.createLoad',
  (params: {
    expectedShipDate?: CalendarDate;
    description?: string;
    salesOrderId?: string;
    bookingId?: string;
    facilityId: string;
    currencyCode?: CurrencyCode | null;
    shippingCarrierName?: string;
    scac?: string;
    freightForwarder?: string;
    truckFreight?: string;
    deliveryNumber?: string;
    documentNumber?: string;
    releaseNumber?: string;
    driverName?: string;
    truckNumber?: string;
    trailerNumber?: string;
    containerNumber?: string;
    sealNumber?: string;
    internalNotes?: string;
    externalNotes?: string;
    lineItems?: LoadLineItemInput[];
    weightDisplayUnit?: WeightDisplayUnit | null;
    outboundTollingAgreementId?: string;
  }) => {
    const input: LoadInput = {
      facilityId: params.facilityId,
    };

    if (params.expectedShipDate)
      input.expectedShipDate = params.expectedShipDate.toString();
    if (params.description) input.description = params.description;
    if (params.salesOrderId) input.salesOrderId = params.salesOrderId;
    if (params.bookingId) input.bookingId = params.bookingId;
    if (params.currencyCode) input.currencyCode = params.currencyCode;
    if (params.shippingCarrierName)
      input.shippingCarrierName = params.shippingCarrierName;
    if (params.scac) input.scac = params.scac;
    if (params.freightForwarder)
      input.freightForwarder = params.freightForwarder;
    if (params.truckFreight) input.truckFreight = params.truckFreight;
    if (params.deliveryNumber) input.deliveryNumber = params.deliveryNumber;
    if (params.documentNumber) input.documentNumber = params.documentNumber;
    if (params.releaseNumber) input.releaseNumber = params.releaseNumber;
    if (params.driverName) input.driverName = params.driverName;
    if (params.truckNumber) input.truckNumber = params.truckNumber;
    if (params.trailerNumber) input.trailerNumber = params.trailerNumber;
    if (params.containerNumber) input.containerNumber = params.containerNumber;
    if (params.sealNumber) input.sealNumber = params.sealNumber;
    if (params.internalNotes)
      input.recyclerInternalNotes = params.internalNotes;
    if (params.externalNotes)
      input.recyclerExternalNotes = params.externalNotes;
    if (params.lineItems) input.lineItems = params.lineItems;
    if (params.weightDisplayUnit)
      input.weightDisplayUnit = params.weightDisplayUnit;
    if (params.outboundTollingAgreementId)
      input.outboundTollingAgreementId = params.outboundTollingAgreementId;

    return {
      tradeLoadCreate: {
        __args: {
          input,
        },
        id: true,
        status: true,
        currencyCode: true,
        expectedShipDate: true,
        description: true,
        salesOrderId: true,
        bookingId: true,
        facilityId: true,
        shippingCarrierName: true,
        scac: true,
        freightForwarder: true,
        truckFreight: true,
        deliveryNumber: true,
        releaseNumber: true,
        driverName: true,
        truckNumber: true,
        trailerNumber: true,
        containerNumber: true,
        sealNumber: true,
        containerTypeId: true,
        containerType: {
          id: true,
          name: true,
        },
        outboundTollingAgreementId: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
    };
  },
);
